import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=3e2d75d3&scoped=true"
import script from "./QuestionContent.ts?vue&type=script&lang=ts&external"
export * from "./QuestionContent.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=3e2d75d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d75d3",
  null
  
)

export default component.exports